import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Availability } from '../../../models/availability';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AvailabilityTypeEnum } from '../../../enum/availability-type.enum';

@Injectable({
    providedIn: 'root'
})
export class AvailabilityService {

    constructor(private http: HttpClient) {
    }

    queryByCourier(courierModule: string): Observable<Availability[]> {
        const params = new HttpParams()
            .set('courier', courierModule);
        return this.http.get<any>(`${environment.apiUrl}/availability`, { params });
    }

    queryByShipment(shipmentNumber: string): Observable<Availability[]> {
        const params = new HttpParams()
            .set('shipment', shipmentNumber);
        return this.http.get<Availability[]>(`${environment.apiUrl}/availability`, { params });
    }

    queryByShipments(shipmentSelection: string[]): Observable<Availability[]> {
        const params = new HttpParams()
            .set('shipments', shipmentSelection.join(','))
            .set('type', AvailabilityTypeEnum.PICKUP);
        return this.http.get<Availability[]>(`${environment.apiUrl}/availability`, { params });
    }

}
